// กันกดผิด: หลังกด "ทำแล้ว"/"ข้าม" บนการ์ด insight จะมีแถบล่างจอพร้อมปุ่ม "ยกเลิก" ราว 6 วินาที
// บันทึกลง server ทันที (ไม่หายแม้ปิดหน้า) — กด "ยกเลิก" = ส่งสถานะเดิมกลับไป
// วาง <InsightUndoSnackbar /> ไว้ที่เดียวใน AppLayout แล้วเรียก showInsightUndo() จากที่ไหนก็ได้
import React, { useEffect, useState } from 'react';
import { Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

let listener = null;

// { message, onUndo } — เรียกซ้ำระหว่างแถบยังแสดงอยู่ = แทนที่ด้วยรายการล่าสุด
export function showInsightUndo(payload) {
  listener?.(payload);
}

export default function InsightUndoSnackbar() {
  const [item, setItem] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    listener = payload => { setItem({ ...payload, key: Date.now() }); setOpen(true); };
    return () => { listener = null; };
  }, []);

  const close = (_e, reason) => { if (reason !== 'clickaway') setOpen(false); };

  return (
    <Snackbar
      key={item?.key}
      open={open}
      onClose={close}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={item?.message}
      action={(
        <>
          <Button
            size="small" color="warning" sx={{ fontWeight: 700 }}
            onClick={() => { setOpen(false); item?.onUndo?.(); }}
          >
            ยกเลิก
          </Button>
          <IconButton size="small" color="inherit" aria-label="ปิด" onClick={() => setOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      )}
    />
  );
}
